<section class="container">
  <h1 class="page-title">Search My Submissions</h1>
  <div class="hover-red pb-1 mt-3">
    <a tabindex="0" class="btn btn-link hover-red" (click)="onPrevious()">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      <span class="ps-2">Back to TennCare Access Welcome Page</span>
    </a>
  </div>
  <div class="row mt-3">
    <div class="card card-body ie-specific">
      <h2 class="section-header">Search Criteria</h2>
      <hr />
      <p>
        Use the Search criteria below to look for completed or in-progress
        applications. For best results, use the full name of the applicant or
        organization. But, a partial entry will also return results.
      </p>
      <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
        <div class="px-1 py-4">
          <div class="row g-3">
            <div class="col-md-3">
              <nh-field
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="First Name"
                class="label-section"
              >
                <input
                  type="text"
                  aria-label="firstName"
                  name="firstName"
                  formControlName="firstName"
                  class="form-control"
                  maxlength="45"
                />
              </nh-field>
            </div>

            <div class="col-lg-2 col-md-3 pl-1">
              <nh-field
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Middle Initial"
                class="label-section"
              >
                <input
                  type="text"
                  aria-label="middleIntial"
                  name="middleIntial"
                  formControlName="middleIntial"
                  mask="S"
                  class="form-control"
                />
              </nh-field>
            </div>

            <div class="col-md-3 pl-1">
              <nh-field
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Last Name"
                class="label-section"
              >
                <input
                  type="text"
                  aria-label="lastName"
                  name="lastName"
                  formControlName="lastName"
                  class="form-control"
                  maxlength="45"
                />
              </nh-field>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Social Security Number"
            class="label-section"
          >
            <input
              type="text"
              name="ssn"
              aria-label="Social Security Number"
              formControlName="ssn"
              class="form-control"
              placeholder="XXX-XX-XXXX"
              mask="000-00-0000"
            />
          </nh-field>
        </div>

        <div class="mt-3">
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Submission Status"
            class="label-section"
          >
            <select
              nh
              name="subStatus"
              aria-label="submission status"
              [items]="submissionStatusArr"
              bindLabel="enDescription"
              bindValue="subStatus"
              formControlName="subStatus"
            ></select>
          </nh-field>
        </div>

        <div class="mt-3">
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Submission Type"
            class="label-section"
          >
            <select
              nh
              name="subType"
              [items]="submissionTypes"
              aria-label="submission type"
              bindLabel="enDescription"
              bindValue="subType"
              formControlName="subType"
              (change)="subTypeChange()"
            ></select>
          </nh-field>
        </div>

        @if (showApp) {
        <div class="mt-3">
          <nh-field
            [mandatory]="showApp"
            [attr.aria-required]="showApp"
            [label]="typeApp"
            class="label-section"
          >
            <input
              type="text"
              [attr.aria-label]="typeApp"
              name="appChangeRenewReass"
              formControlName="appChangeRenewReass"
              mask="S00000000"
              aria-required="true"
              class="form-control"
            />
          </nh-field>
        </div>
        } @if (sup) {
        <div class="mt-3">
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Username"
            class="label-section"
          >
            <input
              type="text"
              aria-label="userName"
              name="userName"
              formControlName="userName"
              class="form-control"
              maxlength="21"
            />
          </nh-field>
        </div>
        } @if (sup) {
        <div class="mt-3 mb-3">
          <nh-field
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Organization Name"
            class="label-section"
          >
            <input
              type="text"
              aria-label="Organization Name"
              name="orgName"
              formControlName="orgName"
              class="form-control"
              maxlength="21"
            />
          </nh-field>
        </div>
        }

        <label class="label-section">Submission Date Range</label>

        <div class="py-4 submission-search">
          <div class="mb-3">
            <nh-field
              [mandatory]="false"
              [attr.aria-required]="false"
              label="Begin Date"
              class="label-section"
            >
              <nh-datepicker>
                <input
                  type="text"
                  class="form-control"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  (change)="isInvalidDate($event)"
                  aria-label="Submission Begin Date"
                  name="subBeginDate"
                  formControlName="subBeginDate"
                  bsDatepicker
                  nh
                />
              </nh-datepicker>
            </nh-field>

            <nh-field
              [mandatory]="false"
              [attr.aria-required]="false"
              label="End Date"
              class="label-section"
            >
              <nh-datepicker>
                <input
                  type="text"
                  class="form-control"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  (change)="isInvalidDate($event)"
                  aria-label="Submission End Date"
                  name="subEndDate"
                  formControlName="subEndDate"
                  bsDatepicker
                  nh
                />
              </nh-datepicker>
            </nh-field>
            <br />
            <div class="pr-md-1 py-sm-1">
              <button class="btn btn-secondary" [disabled]="!searchForm.valid">
                Search&nbsp; <i class="fa fa-search"></i>
              </button>
            </div>

            <br />
          </div>
        </div>
      </form>

      <nh-submission-search-results
        [submissionType]="submission"
        [results]="results"
        (reload)="reload()"
      ></nh-submission-search-results>

      <p class="mt-3">
        *For more information about what you may see in the <strong>Upload Documents</strong> 
        column, review the sections below.
      </p>

      <mat-accordion multi class="info-accordion">
        <!-- Upload Button Panel -->
        <mat-expansion-panel class="info-expansion-panel">
          <mat-expansion-panel-header class="info-header">
            <mat-panel-title class="info-panel-title">
              <strong class="info-title">Upload Button</strong>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="info-content">
            <p>
              An <strong>Upload</strong> button will display for any submitted 
              applications that we have not started reviewing. For these applications, 
              the applicant can submit proof now or wait until we review the application 
              so we can tell them what proof we need. If you don't see the 
              <strong>Upload</strong> button, we've started reviewing the application
              so you can't upload them now.  Once we finish the application review, 
              we will send them a letter telling them what we need. They can use a 
              TennCare Connect account to upload them.
            </p>
          </div>
        </mat-expansion-panel>

        <!-- 2350 Form Panel -->
        <mat-expansion-panel class="info-expansion-panel">
          <mat-expansion-panel-header class="info-header">
            <mat-panel-title class="info-panel-title">
              <strong class="info-title">2350 Form</strong>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="info-content">
            <p>
              A <strong>2350 Form</strong> button will display for any 
              Full Coverage applications that have an approved or terminated 
              segment for at least one of the following coverage types:
            </p>
            <ul>
              <li>SSI Cash Recipient</li>
              <li>Institutional Medicaid Aged</li>
              <li>Institutional Medicaid Blind</li>
              <li>Institutional Medicaid Disabled</li>
            </ul>
            <p>
              This form is optional and is typically used when an individual
              is admitted to or discharged from a long-term care facility.
            </p>
          </div>
        </mat-expansion-panel>

        <!-- Incurred Medical Expenses Panel -->
        <mat-expansion-panel class="info-expansion-panel">
          <mat-expansion-panel-header class="info-header">
            <mat-panel-title class="info-panel-title">
              <strong class="info-title">Incurred Medical Expenses</strong>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="info-content">
            <p>
              To view the documents you uploaded for Incurred Medical Expense
              submissions go to <strong>My Documents</strong> using View TennCare Connect.
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</section>